import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

const AdminGuard = ({ children }) => {
 const API_URL = process.env.REACT_APP_API_URL;
  const {
    data: authUser,
    isPending,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["authUser"],
    queryFn: async () => {
      try {
        const res = await fetch(`${API_URL}/auth/me`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("gameport")}`,
          },
        });
        const data = await res.json();
        if (data.error) return null;
        if (!res.ok) {
          throw new Error(data.message || "something went wrong");
        }
       
        return data;
      } catch (error) {
        throw new toast.error(error);
      }
    },
    retry: false,
  });

  if (isLoading) return <p className="text-center">Loading...</p>;

  if (isError || authUser?.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminGuard;
